<template>
  <generic-list-item
    class="generic-list-item--vendor"
    :title="item.name"
    :text="item.intro"
    badge-text="justopp.vendor.listItem.badgeText"
    :translate-badge-text="true"
    badge-theme="lead"
    badge-icon="user"
    :image-url="item.heroImageUrl"
    :tags="item.Tags"
    :item-route="finalItemRoute">
    <template #actions>
      <router-link v-slot="{ navigate }" :to="finalItemRoute" custom>
        <form-button
          theme="lead"
          icon-end="chevron-inline-end"
          @click="navigateAndRequestClose(navigate)">
          {{ translate("justopp.vendor.listItem.ctaView") }}
        </form-button>
      </router-link>

      <router-link v-slot="{ navigate }" :to="finalItemRouteChat" custom>
        <form-button
          theme="alt"
          icon="chat-message-alt"
          @click="navigateAndRequestClose(navigate)">
          {{ translate("justopp.vendor.listItem.ctaMessage") }}
        </form-button>
      </router-link>
    </template>
  </generic-list-item>
</template>

<script>
import GenericListItem from "@/client/applications/justopp/components/items/generic/ListItem.vue";

export default {
  components: {
    GenericListItem,
  },
  props: {
    item: {
      type: Object,
      default: false,
    },
    itemRoute: {
      type: [Object, Boolean],
      default: false,
    },
  },
  emits: ["list-item:request-close"],
  data: function () {
    return {};
  },
  computed: {
    finalItemRoute() {
      if (this.itemRoute) {
        return this.itemRoute;
      }

      return { name: "store-vendor-id", params: { id: this.item.id, startChat: false } };
    },
    finalItemRouteChat() {
      return {
        name: "store-vendor-id",
        params: { id: this.item.id, startChat: true },
        query: { startChat: true },
      };
    },
  },
  watch: {
    item: {
      handler(newVal) {
        //    console.log("item", newVal);
      },
      immediate: true,
    },
  },
  methods: {
    navigateAndRequestClose(navigationFunction) {
      this.$emit("list-item:request-close", { item: this });
      navigationFunction();
    },
  },
};
</script>

<style scoped lang="scss"></style>
